export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="mb-8 max-md:mb-6 flex items-start justify-between gap-6 max-md:gap-4 flex-wrap" data-testid={testId}>
      <div className="min-w-0">
        <div className="text-xs uppercase tracking-widest text-muted-foreground font-heading mb-2">Overview</div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight text-foreground max-md:text-[1.75rem] max-md:leading-tight break-words">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-2 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
      {actions && <div className="page-actions flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, hint, testId, tone = "default" }) {
  const toneMap = {
    default: "text-foreground",
    good: "text-primary",
    warn: "text-accent",
    bad: "text-destructive",
  };
  return (
    <div data-testid={testId} className="border border-border rounded-md bg-card p-5 max-md:p-4 min-w-0 hover:-translate-y-0.5 hover:shadow-sm transition-transform">
      <div className="text-xs uppercase tracking-widest text-muted-foreground font-heading max-md:text-[10px]">{label}</div>
      <div className={`mt-3 font-heading text-3xl font-bold tabular max-md:mt-2 max-md:text-lg break-words ${toneMap[tone]}`}>{value}</div>
      {hint && <div className="mt-1 text-xs text-muted-foreground">{hint}</div>}
    </div>
  );
}

export function StatusBadge({ status, testId }) {
  const map = {
    active: "bg-green-100 text-green-800 border-green-200",
    paid: "bg-green-100 text-green-800 border-green-200",
    paused: "bg-orange-100 text-orange-800 border-orange-200",
    pending: "bg-amber-100 text-amber-900 border-amber-200",
    partial: "bg-blue-100 text-blue-800 border-blue-200",
    overdue: "bg-red-100 text-red-800 border-red-200",
    transferred: "bg-stone-200 text-stone-700 border-stone-300",
    approved: "bg-green-100 text-green-800 border-green-200",
    rejected: "bg-red-100 text-red-800 border-red-200",
    inactive: "bg-stone-200 text-stone-700 border-stone-300",
    void: "bg-stone-300 text-stone-800 border-stone-400 line-through",
    discounted: "bg-purple-100 text-purple-800 border-purple-200",
  };
  return (
    <span data-testid={testId} className={`inline-flex items-center px-2 py-1 text-[10px] uppercase tracking-wider font-semibold rounded border ${map[status] || "bg-muted text-muted-foreground border-border"}`}>
      {status}
    </span>
  );
}

export function FilterChips({ options, value, onChange, testId = "filter-chips" }) {
  return (
    <div data-testid={testId} className="md:hidden sticky top-[calc(3.5rem+env(safe-area-inset-top))] z-20 -mx-4 px-4 py-2 mb-3 bg-background/90 backdrop-blur-md flex gap-2 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      {options.map((o) => {
        const active = o.value === value;
        return (
          <button key={o.value} type="button" data-testid={`${testId}-${o.value}`} aria-pressed={active}
            onClick={() => onChange(o.value)}
            className={`shrink-0 h-9 px-4 rounded-full border text-[13px] font-medium inline-flex items-center gap-1.5 transition-colors active:scale-95 ${
              active ? "bg-primary text-primary-foreground border-primary" : "bg-card text-foreground border-border"}`}>
            {o.label}
            {o.count !== undefined && <span className={`tabular text-[11px] ${active ? "opacity-80" : "text-muted-foreground"}`}>{o.count}</span>}
          </button>
        );
      })}
    </div>
  );
}

